import { render } from "./RequestLogs.vue?vue&type=template&id=180757b5&scoped=true&ts=true"
import script from "./RequestLogs.vue?vue&type=script&lang=ts"
export * from "./RequestLogs.vue?vue&type=script&lang=ts"

import "./RequestLogs.vue?vue&type=style&index=0&id=180757b5&scoped=true&lang=css"

import exportComponent from "C:\\Build\\vsts-agent-win-x64-3.218.0\\_work\\1\\s\\Connect\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-180757b5"]])

export default __exports__